<div class="container">
    <div class="row">
        <div class="col-12 my-5 position-relative px-0">
            <img src="./assets/images/banner-gasa.png" class="w-100">
            <div class="overlay-text text-light">
                <h2>{{ menuData?.AppName }}</h2>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="menuData && menuData.detail">
        <ng-container *ngFor="let menuItem of menuData.detail">
            <ng-container *ngIf="menuItem.Menu.ISDINAMYC != false">
                <div id="hely" class="col-2">
                    <a class="card h-100 rounded-5 shadow-none animated" [href]="menuItem.Menu.link" (click)="onMenuClick(menuItem.Menu)">
                        <div class="card-body">
                            <div class="card-icon d-flex align-items-middle justify-content-center mb-3 animated">
                                <img class="azul-01" [src]="'./assets/images/sidenav-icons/azul-01/' + menuItem.Menu.icon" />
                                <img class="blanco" [src]="'./assets/images/sidenav-icons/blanco/' + menuItem.Menu.icon" />
                            </div>
                            <h5 class="card-title animated">{{ menuItem.Menu.label }}</h5>
                        </div>
                    </a>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
